import AxiosService from '../axios-service/AxiosService'
const managerBff = process.env.REACT_APP_MANAGER_BFF_URL

export default class InviteService {
    static findMiniApp = (token: string) => {
        return AxiosService.httpGet(managerBff + `/v1/invites/${token}`)
    }

    static acceptInvite = (token: string) => {
        return AxiosService.httpPut(managerBff + `/v1/invites/${token}/accept`)
    }
}
